import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as PIXI from 'pixi.js';
import { Spine } from 'pixi-spine';
import { gsap, CustomEase } from 'gsap';
import { PixiPlugin } from 'gsap/PixiPlugin.js';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin.js';
import { BrowserRouter } from 'react-router-dom';

import reportWebVitals from './reportWebVitals';
import { PixiBase } from 'bog-arcade-core-ui';
import { resourceHelper } from './core/resourceHelper';
import { init } from './core/init';

import './index.css';
import 'react-toastify/dist/ReactToastify.css';

window.PIXI = PIXI;
PixiBase.PIXI = PIXI;
window.PIXI.spine = { Spine };
PixiBase.memoHelper = resourceHelper;
gsap.registerPlugin(PixiPlugin, MotionPathPlugin, CustomEase);
init();

const App = React.lazy(() => import('./App'));

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={null}>
        <App/>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
